import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";
import { fetchPranthList } from './pranthService'; // Adjust path as needed
import { useMemo } from "react";

const ListUsers = () => {

  const handleRedirect = () => {
    navigate("/createfranchise");
  }
  const [Users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const UsersPerPage = 15;
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const [pranthList, setPranthList] = useState([]);
  const [vibhagList, setVibhagList] = useState([]);
  const [selectedPranthId, setSelectedPranthId] = useState(1);
  const [selectedVibhagId, setSelectedVibhagId] = useState("");

  const [jillaList, setJillaList] = useState([]);
  const [selectedJillaId, setSelectedJillaId] = useState("");

  const [khandList, setKhandList] = useState([]);
  const [selectedKhandId, setSelectedKhandId] = useState("");

  const [mandalamList, setMandalamList] = useState([]);
  const [selectedMandalamId, setSelectedMandalamId] = useState("");

  const [selectedRole, setSelectedRole] = useState("");

  const [arthiksakhasList, setArthiksakhasList] = useState([]);
  const [selectedArthiksakhasId, setSelectedArthiksakhasId] = useState("");


  // const [apiUrl, setApiUrl] = useState("");
  // const [apiResponse, setApiResponse] = useState("");

  // const fetchPranthList = async () => {
  //   try {
  //     // const res = await axiosPrivate.get("list-pranths");
  //     // setPranthList(res.data);
  //     setPranthList([
  //       { id: "1", name: "ഉത്തര കേരളം" },
  //       { id: "2", name: "ദക്ഷിണ കേരളം" },
  //     ]);
  //   } catch (err) {
  //     console.error("Failed to fetch pranths", err);
  //     // setPranthList([
  //     //   { id: "1", name: "ഉത്തര കേരളം" },
  //     //   { id: "2", name: "ദക്ഷിണ കേരളം" },
  //     // ]);
  //   }
  // };




  useEffect(() => {
    const getPranths = async () => {
      const data = await fetchPranthList(); // Get data from the service
      setPranthList(data);                  // Set data to state
    };

    getPranths();
  }, []);


  const fetchVibhagList = async (pranthId) => {
    try {
      const res = await axiosPrivate.get(`list-vibhags?pranth_id=${pranthId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setVibhagList(data);
      return data;
    } catch (err) {
      console.error("Failed to fetch vibhags", err);
      setVibhagList([]);
      return [];
    }
  };


  const fetchJillaList = useCallback(async () => {
    try {
      const res = await axiosPrivate.get(`list-jillas?vibhag_id=${selectedVibhagId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setJillaList(data);
      if (data.length > 0) {
        setSelectedJillaId(data[0].jilla_id); // default selection
      } else {
        setSelectedJillaId("");
      }
    } catch (err) {
      console.error("Jilla fetch failed:", err);
      setError("Failed to load jilla list");
      setJillaList([]);
      setSelectedJillaId("");
    }
  }, [axiosPrivate, selectedVibhagId]);





  const fetchKhands = useCallback(async () => {
    if (!selectedJillaId) return;

    setLoading(true);

    try {
      const res = await axiosPrivate.get(`list-khands?jilla_id=${selectedJillaId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setKhandList(data);
      if (data.length > 0) {
        setSelectedKhandId(data[0].khand_id); // optional default
      } else {
        setSelectedKhandId("");
      }
    } catch (err) {
      console.error("Khand fetch failed:", err);
      setError("Failed to load Khand list");
      setKhandList([]);
      setSelectedKhandId("");
    } finally {
      setLoading(false);
    }
  }, [axiosPrivate, selectedJillaId]);



  useEffect(() => {
    fetchPranthList();
  }, []);

  useEffect(() => {
    if (selectedPranthId) {
      fetchVibhagList(selectedPranthId).then((vibhags) => {
        if (vibhags.length > 0) {
          setSelectedVibhagId(vibhags[0].vibhag_id);
        } else {
          setSelectedVibhagId("");
          setVibhagList([]);
          setSelectedJillaId("");
          setJillaList([]);

          setKhandList([]);              // ✅ Add this line
          setSelectedKhandId("");        // ✅ Add this line
          setMandalamList([]);              // ✅ Add this line
          setSelectedMandalamId("");        // ✅ Add this line
          setError("No vibhags for selected pranth");
        }
      });
    }
  }, [selectedPranthId]);



  useEffect(() => {
    if (selectedVibhagId) {
      fetchJillaList();
    }
  }, [selectedVibhagId]);

  // useEffect(() => {
  //   if (selectedJillaId) {
  //     setCurrentPage(1); // Reset to page 1 when Jilla changes
  //     setError(null);
  //     setLoading(true);
  //     fetchKhands();
  //   }
  // }, [selectedJillaId]);
  useEffect(() => {
    if (selectedJillaId) {
      fetchKhands();
    }
  }, [selectedJillaId]);




  const parentLevelId = useMemo(() => {
    switch (selectedRole) {
      case "Vibhag":
        return selectedPranthId;

      case "Jilla":
        return selectedVibhagId;

      case "Khand":
        return selectedJillaId;

      case "Sthan":
        return selectedMandalamId;

      case "Arthiksakha":
        return selectedPranthId;

      default:
        return "";
    }
  }, [
    selectedRole,
    selectedPranthId,
    selectedVibhagId,
    selectedJillaId,
    selectedMandalamId,
  ]);

  useEffect(() => {
    if (!selectedRole || !parentLevelId) {
      setUsers([]);
      // setApiUrl("");
      // setApiResponse("");
      return;
    }

    const url = `admin/list-users?role=${selectedRole}&parent_level_id=${parentLevelId}`;

    // setApiUrl(url);

    const fetchTableData = async () => {
      // Clear previous data before fetching
      setUsers([]);
      setError(null);
      // setApiResponse("");
      setLoading(true);

      try {
        const res = await axiosPrivate.get(url);

        // setApiResponse(JSON.stringify(res.data, null, 2));
        setUsers(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        // setApiResponse(
        //   JSON.stringify(
        //     {
        //       message: err.message,
        //       status: err.response?.status,
        //       data: err.response?.data,
        //     },
        //     null,
        //     2
        //   )
        // );

        setUsers([]);
        setError("Failed to load users");
      } finally {
        setLoading(false);
      }
    };

    fetchTableData();
  }, [selectedRole, parentLevelId, axiosPrivate]);


  const fetchArthiksakhaList = async (pranthId) => {
    try {
      const res = await axiosPrivate.get(`list-arthik-sakhas?pranth_id=${pranthId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setArthiksakhasList(data);
      return data;
    } catch (err) {
      console.error("Failed to fetch Arthiksakha", err);
      setArthiksakhasList([]);
      return [];
    }
  };


  useEffect(() => {
    if (selectedPranthId) {
      fetchArthiksakhaList(selectedPranthId).then((vibhags) => {
        if (vibhags.length > 0) {
          setSelectedArthiksakhasId(vibhags[0].vibhag_id);
        } else {
          setSelectedArthiksakhasId("");
          setArthiksakhasList([]);

          setKhandList([]);              // ✅ Add this line
          setSelectedKhandId("");        // ✅ Add this line
          setMandalamList([]);              // ✅ Add this line
          setSelectedMandalamId("");        // ✅ Add this line
          // setError("No vibhags for selected pranth");
        }
      });
    }
  }, [selectedPranthId]);


  useEffect(() => {
    const fetchMandalamList = async () => {
      if (!selectedKhandId) {
        setMandalamList([]);
        setSelectedMandalamId("");

        return;
      }

      setLoading(true);
      try {
        const res = await axiosPrivate.get(`list-mandals?khand_id=${selectedKhandId}`);
        const data = Array.isArray(res.data) ? res.data : [];
        setMandalamList(data);
        if (data.length > 0) {
          const firstMandalamId = data[0].mandal_id;
          setSelectedMandalamId("");  // force change
          setTimeout(() => {
            setSelectedMandalamId(firstMandalamId);  // re-trigger useEffect
          }, 0);
        } else {
          setSelectedMandalamId("");

        }

      } catch (err) {
        console.error("User fetch failed:", err);
        setError("Failed to load User list");
        setMandalamList([]);
        setSelectedMandalamId("");

      } finally {
        setLoading(false);
      }
    };

    fetchMandalamList();
  }, [selectedKhandId]);






  const indexOfLastUsers = currentPage * UsersPerPage;
  const indexOfFirstUsers = indexOfLastUsers - UsersPerPage;
  const currentUsers = Users.slice(indexOfFirstUsers, indexOfLastUsers);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(Users.length / UsersPerPage);

  // if (loading) {
  //   return <div className="loading">Loading...</div>;
  // }

  // if (error) {
  //   return <div className="error">{error}</div>;
  // }

  return (
    <>
      {/* <Container> */}
      <section className="empbody">
        <div className="wrapperemp2">
          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
          {/* <p
            className={apiUrl ? "sucssmsg" : "offscreen"}
            aria-live="assertive"
          >
            {apiUrl}
          </p>

          <p
            className={apiUrl ? "sucssmsg" : "offscreen"}
            aria-live="assertive"
          >
            Role: {selectedRole} |
            Parent ID: {parentLevelId} |
            URL: {apiUrl}
          </p>

          <p
            className={apiResponse ? "sucssmsg" : "offscreen"}
            aria-live="assertive"
            style={{
              whiteSpace: "pre-wrap",
              maxHeight: "300px",
              overflow: "auto",
              fontSize: "12px",
              background: "#f5f5f5",
              padding: "10px"
            }}
          >
            {apiResponse}
          </p> */}




          {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create User</button> */}
          <h3>List Users</h3>
          <Row className="mb-3">
            <Col md={2}>
              <Form.Label className="newformstyle">Role</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedRole}
                onChange={(e) => setSelectedRole(e.target.value)}
              >
                <option value="">-- Select Role --</option>
                <option value="Vibhag">Vibhag</option>
                <option value="Jilla">Jilla</option>
                <option value="Khand">Khand</option>
                <option value="Sthan">Sthan</option>
                <option value="Arthiksakha">Arthiksakha</option>
              </Form.Select>
            </Col>
            <Col md={2}>
              <Form.Label className="newformstyle">Select Pranth</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedPranthId}
                onChange={(e) => {
                  const pranthId = e.target.value;
                  setSelectedPranthId(pranthId);

                  if (!pranthId) {
                    // Clear vibhag, jilla, and table if no Pranth selected
                    setVibhagList([]);
                    setSelectedVibhagId("");
                    setJillaList([]);
                    setSelectedJillaId("");


                    setKhandList([]);
                    setSelectedKhandId("");

                  }
                }}
              >
                <option value="">-- Select Pranth --</option>
                {pranthList.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </Form.Select>

            </Col>

            {selectedRole !== "Arthiksakha" && selectedRole !== "Vibhag" && (
              <Col md={2}>
                <Form.Label className="newformstyle">Select Vibhag</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedVibhagId}
                  onChange={(e) => {
                    const vibhagId = e.target.value;
                    setSelectedVibhagId(vibhagId);

                    if (!vibhagId) {
                      // Clear Jilla list and selection if no Vibhag selected
                      setJillaList([]);
                      setSelectedJillaId("");


                      setKhandList([]);
                      setSelectedKhandId("");

                    }
                  }}
                  disabled={!vibhagList.length}
                >
                  <option value="">-- Select Vibhag --</option>
                  {Array.isArray(vibhagList) &&
                    vibhagList.map((v) => (
                      <option key={v.vibhag_id} value={v.vibhag_id}>
                        {v.vibhag_name}
                      </option>
                    ))}
                </Form.Select>
              </Col>
            )}

            {["Khand", "Sthan"].includes(selectedRole) && (
              <Col md={2}>
                <Form.Label className="newformstyle">Select Jilla</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedJillaId}
                  onChange={(e) => {
                    const jillaId = e.target.value;
                    setSelectedJillaId(jillaId);

                    if (!jillaId) {
                      setKhandList([]);
                      setSelectedKhandId("");

                    }
                  }}
                  disabled={!jillaList.length}
                >
                  <option value="">-- Select Jilla --</option>
                  {jillaList.map((j) => (
                    <option key={j.jilla_id} value={j.jilla_id}>
                      {j.jilla_name}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            )}

            {["Sthan"].includes(selectedRole) && (
              <Col md={2}>
                <Form.Label className="newformstyle">Select Khand</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedKhandId}
                  onChange={(e) => setSelectedKhandId(e.target.value)}
                  disabled={!khandList.length}
                >
                  <option value="">-- Select Khand --</option>
                  {khandList.map((k) => (
                    <option key={k.khand_id} value={k.khand_id}>
                      {k.khand_name}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            )}
            {selectedRole === "Sthan" && (
              <Col md={2}>
                <Form.Label className="newformstyle">Select Mandalam</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedMandalamId}
                  onChange={(e) => {
                    const mandalamId = e.target.value;
                    setSelectedMandalamId(mandalamId); // Correctly set Mandalam ID
                    // Remove this:
                    // setSelectedKhandId(khandId);
                    // setMandalamList([]);

                  }}
                  disabled={!mandalamList.length}
                >

                  <option value="">-- Select Mandalam --</option>
                  {mandalamList.map((m) => (
                    <option key={m.mandal_id} value={m.mandal_id}>
                      {m.mandal_name}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            )}


            {/* {selectedRole === "Arthiksakha" && (
              <Col md={2}>
                <Form.Label className="newformstyle">Arthiksakha</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedArthiksakhasId}
                  onChange={(e) => {
                    const ArthiksaId = e.target.value;
                    setSelectedArthiksakhasId(ArthiksaId);
                  }}
                  disabled={!arthiksakhasList.length}
                >
                  <option value="">-- Select Arthiksakhas --</option>
                  {Array.isArray(arthiksakhasList) &&
                    arthiksakhasList.map((v) => (
                      <option key={v.arthik_sakha_id} value={v.arthik_sakha_id}>
                        {v.arthik_sakha}
                      </option>
                    ))}
                </Form.Select>
              </Col>
            )} */}
          </Row>

          <table id="customers">
            <thead>
              <tr>
                <th>Name</th>
                <th>Mobile</th>
                <th>Responsibility</th>
                <th>Role</th>
                <th>Level name</th>
                {/* <th>Level name</th> */}
                {/* <th>Options</th> */}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="text-center">
                    Loading...
                  </td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="6" className="text-danger text-center">
                    {error}
                  </td>
                </tr>
              ) : Users.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center">
                    No Users available.
                  </td>
                </tr>
              ) : (
                currentUsers.map((User) => (
                  <tr key={User.person_id}>
                    <td>{User.name}</td>
                    <td>{User.mobile}</td>
                    <td>{User.responsibility}</td>
                    <td>{User.role}</td>
                    <td>{User.level_name}</td>
                  </tr>
                ))
              )}
            </tbody>

          </table>

          {totalPages > 1 && (
            <div className="pagination">
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  disabled={currentPage === index + 1}
                >
                  {index + 1}
                </button>
              ))}
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
            </div>
          )}
        </div>
      </section>
      <TopBar />
      {/* </Container> */}
    </>
  );
};

export default ListUsers;
